import waybillService from "src/services/waybillService";

export const CREATE_WAYBILL_REQUEST = "@waybill/create-waybill-request";
export const CREATE_WAYBILL_REQUEST_SUCCESS = "@waybill/create-waybill-request-success";
export const CREATE_WAYBILL_REQUEST_FAILURE = "@waybill/create-waybill-request-failure";

export const GET_WAYBILL_REQUEST = "@waybill/get-waybill-request";
export const GET_WAYBILL_SUCCESS = "@waybill/get-waybill-success";
export const GET_WAYBILL_FAILURE = "@waybill/get-waybill-failure";

export const GET_WAYBILL_BY_ID_REQUEST = "@waybill/get-waybill-by-id-request";
export const GET_WAYBILL_BY_ID_SUCCESS = "@waybill/get-waybill-by-id-success";
export const GET_WAYBILL_BY_ID_FAILURE = "@waybill/get-waybill-by-id-failure";

export const UPDATE_COD_WAYBILL_REQUEST = "@waybill/update-code-waybill-request";
export const UPDATE_COD_WAYBILL_SUCCESS = "@waybill/update-code-waybill-success";
export const UPDATE_COD_WAYBILL_FAILURE = "@waybill/update-code-waybill-failure";

export const UPDATE_WAYBILL_REQUEST = "@waybill/update-waybill-request";
export const UPDATE_WAYBILL_SUCCESS = "@waybill/update-waybill-success";
export const UPDATE_WAYBILL_FAILURE = "@waybill/update-waybill-failure";

export function requestCreateWaybill(data) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_WAYBILL_REQUEST});
      const response = await waybillService.requestCreateWaybill(data);
      dispatch({
        type: CREATE_WAYBILL_REQUEST_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: CREATE_WAYBILL_REQUEST_FAILURE});
      throw error;
    }
  };
}

export function getRequestWaybill(params) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_WAYBILL_REQUEST});
      const response = await waybillService.getWaybillRequest(params);
      dispatch({
        type: GET_WAYBILL_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_WAYBILL_FAILURE});
      throw error;
    }
  };
}

export function getWaybillById(params) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_WAYBILL_BY_ID_REQUEST});
      const response = await waybillService.getWaybillByIdRequest(params);
      dispatch({
        type: GET_WAYBILL_BY_ID_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_WAYBILL_BY_ID_FAILURE});
      throw error;
    }
  };
}

export function updateCodWaybill(params) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_COD_WAYBILL_REQUEST});
      const response = await waybillService.updateCodRequest(params);
      dispatch({
        type: UPDATE_COD_WAYBILL_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_COD_WAYBILL_FAILURE});
      throw error;
    }
  };
}

export function updateWaybill(params) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_WAYBILL_REQUEST});
      const response = await waybillService.updateWaybillRequest(params);
      dispatch({
        type: UPDATE_WAYBILL_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_WAYBILL_FAILURE});
      throw error;
    }
  };
}
